export const TRANSCRIPT_WORKFLOW_OPTIONS = [
  {
    id: 'translate',
    title: 'Translation',
    description: 'Create a translated transcript version without overwriting the original.',
    details:
      'Best when you want a readable transcript in another language while preserving turn order and speaker context.',
    costLabel: '1 transcription credit',
  },
  {
    id: 'pii_redaction',
    title: 'PII Redaction',
    description: 'Create a redacted transcript version for safer review and sharing.',
    details: 'Uses source media when available and a transcript-text fallback when it is not.',
    costLabel: '1 transcription credit',
  },
  {
    id: 'enhance_transcription',
    title: 'Enhance Transcription',
    description: 'Improve transcript clarity without deleting the original transcript.',
    details:
      'Reruns available source media through the stronger transcription path or cleans transcript text when only text is available.',
    costLabel: '1 transcription credit',
  },
];

export const TRANSCRIPT_LANGUAGE_MODE_OPTIONS = [
  {
    id: 'explicit',
    label: 'Set language manually',
    helper:
      'Use this when the transcript is mostly one language and you want the most predictable routing.',
  },
  {
    id: 'detect',
    label: 'Detect language automatically',
    helper:
      'Best when the source language is unknown. Qualz will choose the best supported language path automatically.',
  },
  {
    id: 'code_switch',
    label: 'Code-switching / bilingual',
    helper:
      'Use this when speakers switch between languages. Qualz currently supports up to two expected languages in this mode, and one should be English.',
  },
];

export const TRANSCRIPT_LANGUAGE_OPTIONS = [
  { code: 'en', label: 'Global English' },
  { code: 'en_au', label: 'Australian English' },
  { code: 'en_uk', label: 'British English' },
  { code: 'en_us', label: 'US English' },
  { code: 'es', label: 'Spanish' },
  { code: 'fr', label: 'French' },
  { code: 'de', label: 'German' },
  { code: 'it', label: 'Italian' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'nl', label: 'Dutch' },
  { code: 'hi', label: 'Hindi' },
  { code: 'ja', label: 'Japanese' },
  { code: 'zh', label: 'Chinese' },
  { code: 'fi', label: 'Finnish' },
  { code: 'ko', label: 'Korean' },
  { code: 'pl', label: 'Polish' },
  { code: 'ru', label: 'Russian' },
  { code: 'tr', label: 'Turkish' },
  { code: 'uk', label: 'Ukrainian' },
  { code: 'vi', label: 'Vietnamese' },
  { code: 'af', label: 'Afrikaans' },
  { code: 'sq', label: 'Albanian' },
  { code: 'am', label: 'Amharic' },
  { code: 'ar', label: 'Arabic' },
  { code: 'hy', label: 'Armenian' },
  { code: 'as', label: 'Assamese' },
  { code: 'az', label: 'Azerbaijani' },
  { code: 'ba', label: 'Bashkir' },
  { code: 'eu', label: 'Basque' },
  { code: 'be', label: 'Belarusian' },
  { code: 'bn', label: 'Bengali' },
  { code: 'bs', label: 'Bosnian' },
  { code: 'br', label: 'Breton' },
  { code: 'bg', label: 'Bulgarian' },
  { code: 'my', label: 'Burmese' },
  { code: 'ca', label: 'Catalan' },
  { code: 'hr', label: 'Croatian' },
  { code: 'cs', label: 'Czech' },
  { code: 'da', label: 'Danish' },
  { code: 'et', label: 'Estonian' },
  { code: 'fo', label: 'Faroese' },
  { code: 'gl', label: 'Galician' },
  { code: 'ka', label: 'Georgian' },
  { code: 'el', label: 'Greek' },
  { code: 'gu', label: 'Gujarati' },
  { code: 'ht', label: 'Haitian' },
  { code: 'ha', label: 'Hausa' },
  { code: 'haw', label: 'Hawaiian' },
  { code: 'he', label: 'Hebrew' },
  { code: 'hu', label: 'Hungarian' },
  { code: 'is', label: 'Icelandic' },
  { code: 'id', label: 'Indonesian' },
  { code: 'jw', label: 'Javanese' },
  { code: 'kn', label: 'Kannada' },
  { code: 'kk', label: 'Kazakh' },
  { code: 'km', label: 'Khmer' },
  { code: 'lo', label: 'Lao' },
  { code: 'la', label: 'Latin' },
  { code: 'lv', label: 'Latvian' },
  { code: 'ln', label: 'Lingala' },
  { code: 'lt', label: 'Lithuanian' },
  { code: 'lb', label: 'Luxembourgish' },
  { code: 'mk', label: 'Macedonian' },
  { code: 'mg', label: 'Malagasy' },
  { code: 'ms', label: 'Malay' },
  { code: 'ml', label: 'Malayalam' },
  { code: 'mt', label: 'Maltese' },
  { code: 'mi', label: 'Maori' },
  { code: 'mr', label: 'Marathi' },
  { code: 'mn', label: 'Mongolian' },
  { code: 'ne', label: 'Nepali' },
  { code: 'no', label: 'Norwegian' },
  { code: 'nn', label: 'Norwegian Nynorsk' },
  { code: 'oc', label: 'Occitan' },
  { code: 'pa', label: 'Punjabi' },
  { code: 'ps', label: 'Pashto' },
  { code: 'fa', label: 'Persian' },
  { code: 'ro', label: 'Romanian' },
  { code: 'sa', label: 'Sanskrit' },
  { code: 'sr', label: 'Serbian' },
  { code: 'sn', label: 'Shona' },
  { code: 'sd', label: 'Sindhi' },
  { code: 'si', label: 'Sinhala' },
  { code: 'sk', label: 'Slovak' },
  { code: 'sl', label: 'Slovenian' },
  { code: 'so', label: 'Somali' },
  { code: 'su', label: 'Sundanese' },
  { code: 'sw', label: 'Swahili' },
  { code: 'sv', label: 'Swedish' },
  { code: 'de_ch', label: 'Swiss German' },
  { code: 'tl', label: 'Tagalog' },
  { code: 'tg', label: 'Tajik' },
  { code: 'ta', label: 'Tamil' },
  { code: 'tt', label: 'Tatar' },
  { code: 'te', label: 'Telugu' },
  { code: 'th', label: 'Thai' },
  { code: 'bo', label: 'Tibetan' },
  { code: 'tk', label: 'Turkmen' },
  { code: 'ur', label: 'Urdu' },
  { code: 'uz', label: 'Uzbek' },
  { code: 'cy', label: 'Welsh' },
  { code: 'yi', label: 'Yiddish' },
  { code: 'yo', label: 'Yoruba' },
];

export const TRANSCRIPT_REDACTION_POLICY_OPTIONS = [
  { value: 'account_number', label: 'Account number' },
  { value: 'banking_information', label: 'Banking information' },
  { value: 'blood_type', label: 'Blood type' },
  { value: 'credit_card_cvv', label: 'Credit card CVV' },
  { value: 'credit_card_expiration', label: 'Credit card expiration' },
  { value: 'credit_card_number', label: 'Credit card number' },
  { value: 'date', label: 'Specific dates' },
  { value: 'date_interval', label: 'Date intervals' },
  { value: 'date_of_birth', label: 'Date of birth' },
  { value: 'drivers_license', label: 'Driver license' },
  { value: 'drug', label: 'Medications and supplements' },
  { value: 'duration', label: 'Durations' },
  { value: 'email_address', label: 'Email address' },
  { value: 'event', label: 'Events and holidays' },
  { value: 'filename', label: 'Filenames and paths' },
  { value: 'gender_sexuality', label: 'Gender and sexuality' },
  { value: 'healthcare_number', label: 'Healthcare numbers' },
  { value: 'injury', label: 'Injuries' },
  { value: 'ip_address', label: 'IP address' },
  { value: 'language', label: 'Language names' },
  { value: 'location', label: 'Locations and addresses' },
  { value: 'marital_status', label: 'Marital status' },
  { value: 'medical_condition', label: 'Medical conditions' },
  { value: 'medical_process', label: 'Medical processes' },
  { value: 'money_amount', label: 'Money amounts' },
  { value: 'nationality', label: 'Nationality and ethnicity' },
  { value: 'number_sequence', label: 'Number sequences' },
  { value: 'occupation', label: 'Occupation' },
  { value: 'organization', label: 'Organization' },
  { value: 'passport_number', label: 'Passport number' },
  { value: 'password', label: 'Passwords and access codes' },
  { value: 'person_age', label: 'Age' },
  { value: 'person_name', label: 'Person name' },
  { value: 'phone_number', label: 'Phone number' },
  { value: 'physical_attribute', label: 'Physical attributes' },
  { value: 'political_affiliation', label: 'Political affiliation' },
  { value: 'religion', label: 'Religion' },
  { value: 'statistics', label: 'Medical statistics' },
  { value: 'time', label: 'Clock time' },
  { value: 'url', label: 'URLs' },
  { value: 'us_social_security_number', label: 'US Social Security number' },
  { value: 'username', label: 'Username' },
  { value: 'vehicle_id', label: 'Vehicle ID / plate' },
  { value: 'zodiac_sign', label: 'Zodiac sign' },
];

export const DEFAULT_REDACTION_POLICIES = [
  'person_name',
  'phone_number',
  'email_address',
  'location',
  'account_number',
  'credit_card_number',
  'us_social_security_number',
];

export const normalizeLanguageCode = (value) => {
  if (!value) return '';
  if (typeof value === 'string') {
    return value.trim().toLowerCase().replace('-', '_');
  }
  return value.code;
};

export const normalizeLanguageArray = (values) =>
  values
    .map((value) => normalizeLanguageCode(value))
    .filter(Boolean)
    .slice(0, 2);

export const formatLanguageOption = (option) => {
  if (typeof option === 'string') {
    const normalized = normalizeLanguageCode(option);
    const matched = TRANSCRIPT_LANGUAGE_OPTIONS.find((item) => item.code === normalized);
    return matched ? `${matched.label} (${matched.code})` : normalized;
  }

  if (!option) return '';
  return `${option.label} (${option.code})`;
};
